import { Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from '@angular/core';
import { differenceInDays, format, formatDuration, intervalToDuration } from 'date-fns';
import {it} from 'date-fns/locale';
import parseISO from 'date-fns/parseISO'
import { ToastrService } from 'ngx-toastr';
import { interval } from 'rxjs';

interface Sconto {
    "codice": string,
    "tipo": number,
    "indicatore_percentuale_assoluto": number,
    "data_inizio": string,
    "data_fine": string,
    "valore": number,
    "utilizzato": number,
    "importo_minimo": number
}

@Component({
  selector: 'app-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.scss']
})
export class CouponComponent implements OnInit {
  @Input() coupon : Sconto;
  @Input() activeCouponCode;
  @Input() totSpesa;
  dataFine;
  dataFineLbl;
  daysRemain;

  @HostListener('click', ['$event.target'])
  onClick(btn) {
    if (this.activeCouponCode == this.coupon.codice) {
      this.onCouponSelected.emit(null);
    }
    else {
      this.onCouponSelected.emit(this.coupon);
    }
  }

  @HostBinding('class.active') get active() { return this.activeCouponCode == this.coupon.codice; }

  @Output() onCouponSelected = new EventEmitter();
  @Output() discountEnd = new EventEmitter();

  constructor() { }

  updateTimer$;

  ngOnInit(): void {
    this.dataFine = parseISO(this.coupon.data_fine);
    this.dataFine.setSeconds(59);
    this.dataFine.setMinutes(59);
    this.dataFine.setHours(23);
    
    this.dataFineLbl = format(this.dataFine, 'd MMMM yyyy', {locale: it});
    if (this.coupon.indicatore_percentuale_assoluto) {
      this.coupon.importo_minimo = Math.max(this.coupon.importo_minimo, this.coupon.valore)
    }

    this.daysRemain = differenceInDays(this.dataFine, new Date());
    if (this.daysRemain < 3) {

      this.updateTimer$ = interval(1000).subscribe(_ => {
        console.log(_);
        let timeRemain = intervalToDuration({
          start: new Date(),
          end: this.dataFine,
        });

        let daysRemain = formatDuration(timeRemain, {format: ['days'], locale: it}) + ' ';
        let hoursRemain = [timeRemain.hours, timeRemain.minutes, timeRemain.seconds].map(n => `${n}`.padStart(2, '0')).join(':');

        this.dataFineLbl = daysRemain + hoursRemain;
        
        if (!this.daysRemain && hoursRemain == '00:00:00') {
          this.updateTimer$.unsubscribe();
          this.discountEnd.emit(this.coupon);
        }
      });
    }
  }

  ngOnDestroy() {
    this.updateTimer$.unsubscribe();
  }

}
